import { makeAutoObservable } from 'mobx'

class LiveOrder {
  constructor () {
    makeAutoObservable(this, {
      cartItemsChangedHandler: false
    })
  }

  cartItemsChangedHandler: number = 0

  private isShowWaiter = false

  needReorder = false

  isMultiEditing = false

  setNeedReorder (isNeedRecorder = true) {
    this.needReorder = isNeedRecorder
  }

  setIsShowWaiter () {
    this.isShowWaiter = true
  }

  pickIsShowWaiter () {
    const theIsShowWaiter = this.isShowWaiter
    this.isShowWaiter = false
    return theIsShowWaiter
  }

  setIsMultiEditing (isMultiEditing: boolean) {
    this.isMultiEditing = isMultiEditing
  }
}

export default new LiveOrder()
